import * as stagesSettlement from "../../Stages/StagesSettlement";
import { translate } from "../../Translations/translatorService";
import { getRequiredFields, validateFields } from "../statusChangeValidators";
import { settlementRequiredFields } from "./settlementRequiredFields";
import { Settlement } from "../../../types/Products/EmploymentLaw/Settlement";
import dayjs from "dayjs";

export const settlementValidators = {
  [stagesSettlement.STAGE_INCOMPLETE]: (settlement: Settlement) => {
    return validateFields(settlementRequiredFields[stagesSettlement.STAGE_INCOMPLETE](settlement), settlement);
  },
  [stagesSettlement.STAGE_READY]: (settlement: Settlement) => {
    return validateFields(settlementRequiredFields[stagesSettlement.STAGE_READY](settlement), settlement);
  },
  [stagesSettlement.STAGE_CHECKED]: (settlement: Settlement) => {
    let errorMessages = validateFields(
      getRequiredFields(settlement, stagesSettlement.STAGE_CHECKED),
      settlement
    );

    const hasCompleteNormalAddress =
      settlement.employerOrganization.address.streetAddress &&
      settlement.employerOrganization.address.postalCode &&
      settlement.employerOrganization.address.addressLocality;

    const hasCompletePostOfficeBoxAddress =
      settlement.employerOrganization.address.postOfficeBoxNumber &&
      settlement.employerOrganization.address.postOfficeBoxPostalCode &&
      settlement.employerOrganization.address.postOfficeBoxAddressLocality;

    if (!hasCompleteNormalAddress && !hasCompletePostOfficeBoxAddress) {
      errorMessages.push(
        "Entweder die Standardadresse oder die Postfachadresse des Arbeitgebers müssen vollständig befüllt sein"
      );
    }

    if (settlement.contract === null) {
      errorMessages.push('Das Dokument "Arbeitsvertrag" fehlt!');
    }

    if (settlement.contractTermination === null) {
      errorMessages.push('Das Dokument "Kündigung" fehlt!');
    }

    return errorMessages;
  },
  [stagesSettlement.STAGE_SUBMITTED]: (settlement: Settlement) => {
    return validateFields(settlementRequiredFields[stagesSettlement.STAGE_SUBMITTED](settlement), settlement);
  },
  [stagesSettlement.STAGE_PAID]: (settlement: Settlement) => {
    return validateFields(settlementRequiredFields[stagesSettlement.STAGE_PAID](settlement), settlement);
  },
  [stagesSettlement.STAGE_DATE_SET_SETTLEMENT]: (settlement: Settlement) => {
    return validateFields(settlementRequiredFields[stagesSettlement.STAGE_DATE_SET_SETTLEMENT](settlement), settlement);
  },
  [stagesSettlement.STAGE_DATE_SET_TRIAL]: (settlement: Settlement) => {
    return validateFields(settlementRequiredFields[stagesSettlement.STAGE_DATE_SET_TRIAL](settlement), settlement);
  },
  [stagesSettlement.STAGE_DECISION_MADE]: (settlement: Settlement) => {
    let errorMessages = validateFields(
      settlementRequiredFields[stagesSettlement.STAGE_DECISION_MADE](settlement),
      settlement
    );

    if (settlement.settlementReachedDate && settlement.finalJudgement) {
      errorMessages.push(
        `${translate("settlement.settlementReachedDate.label")} und ${translate(
          "settlement.finalJudgement.label"
        )} dürfen nicht beide befüllt sein!`
      );
    }
    if (!settlement.settlementReachedDate && !settlement.finalJudgement) {
      errorMessages.push(
        `${translate("settlement.settlementReachedDate.label")} ODER ${translate(
          "settlement.finalJudgement.label"
        )} müssen befüllt sein!`
      );
    }

    return errorMessages;
  },
  [stagesSettlement.STAGE_COMPLETED]: (settlement: Settlement) => {
    let errorMessages = validateFields(
      settlementRequiredFields[stagesSettlement.STAGE_COMPLETED](settlement),
      settlement
    );
    if (
      !(
        settlement.finalJudgement ||
        (settlement.settlementReachedDate &&
          settlement.settlementRevocationDate &&
          dayjs(settlement.settlementRevocationDate).isBefore(dayjs()))
      )
    ) {
      errorMessages.push(`Die Widerrufsfrist des Urteils muss abgelaufen sein!`);
    }

    return errorMessages;
  },
};
